module.exports = "images/ico-twitch.svg";